
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.062 17.846"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.277 16.062H1.785V6.246h12.492m0-4.462h-.892V0H11.6v1.785H4.462V0H2.677v1.785h-.892A1.784 1.784 0 000 3.569v12.493a1.785 1.785 0 001.785 1.785h12.492a1.785 1.785 0 001.785-1.785V3.569a1.785 1.785 0 00-1.785-1.785m-2.2 7.192l-.946-.946-4.358 4.355-1.892-1.891-.946.946 2.838 2.838z"}})])
          )
        }
      }
    